var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full relative"},[_vm._t("default"),_c('div',{staticClass:"icon-swg-dropdown absolute right-4 top-3.5 pointer-events-none"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }